import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { usePendenciesReplies } from './_data/pendencies'
import Accordion from '../../../../components/structure/Accordion'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import PendencyCard from './PendencyCard'
import Tag from '../../../../components/presentation/Tag'

const PendenciesAccordion = () => {
  const { t } = useTranslation('serviceOrders')
  const pendencies = usePendenciesReplies()

  if (!pendencies || !pendencies.length) return false

  const counter = <Tag label={pendencies.length} color={COLORS.purple} medium fixedSize />

  return (
    <FlexCol>
      <Accordion label={t('resume.accordion.pendencies')} side={counter} sticky>
        <FlexGrid direction="column" align="stretch" gutter={0.5}>
          {pendencies.map(item => (
            <PendencyCard key={item.id} reply={item} />
          ))}
        </FlexGrid>
      </Accordion>
    </FlexCol>
  )
}

export default PendenciesAccordion
